// ** React Imports
import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";

// ** Third Party Components
import axios from "axios";

// ** Reactstrap Imports
import { Alert, Col, Row, Spinner } from "reactstrap";

// ** Invoice Preview Components
import PreviewActions from "./PreviewActions";

// ** Styles
import "@styles/base/pages/app-invoice.scss";

import useStorage from "../../../utility/hooks/useStorage";

import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { ErrorHandler } from "../../../common/utils/Error";
import PreviewCard from "./PreviewCard";

const ReceiptPreview = () => {
  // ** HooksVars
  const { id } = useParams();
  const { removeItem } = useStorage();
  const [detail, setDetail] = useState();

  const [searchParams, setSearchParams] = useSearchParams();
  const appView = searchParams.get("view");
  // ** States

  const [sendSidebarOpen, setSendSidebarOpen] = useState(false);
  const [addPaymentOpen, setAddPaymentOpen] = useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ** Functions to toggle add & send sidebar
  const toggleSendSidebar = () => setSendSidebarOpen(!sendSidebarOpen);
  const toggleAddSidebar = () => setAddPaymentOpen(!addPaymentOpen);

  const receiptRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    documentTitle: `${data?.type} Receipt ${data?.receiptNo} - ${data?.customer?.name}`,
    pageStyle: `
    @page {
      size: 210mm 148mm;
      }
      @media print {
      @page {  size: a5 landscape;
          margin: 0mm !important;
      }
    }
    
    @media print {
      html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }
    
    @media print {
      .page-break {
        margin-top: 1rem;
        display: block;
        page-break-before: always !important;
      }
      .card{
        box-shadow:none !important;
      }
    }
    
    @page {
      size: auto;
    }
    `,
    bodyClass: "",
  });

  const getReceiptDetail = async () => {
    setLoading(true);
    try {
      let ids = id.split(",");
      const response = await axios.get(`accountings/receipts/get`, {
        params: { receipts: ids },
      });

      if (response.status == 200) {
        setDetail(response?.data?.data);
      }
    } catch (error) {
      ErrorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    removeItem("printReceipt");
    getReceiptDetail();
  }, []);

  // useEffect(() => {
  //   console.log(detail);
  // }, [detail]);

  return loading ? (
    <div className="d-flex justify-content-center align-items-center">
      {" "}
      <Spinner />{" "}
    </div>
  ) : detail && detail.length ? (
    <div className="invoice-preview-wrapper">
      <Row className="invoice-preview">
        <Col
          lg={{ order: 0, size: 9 }}
          md={{ order: 1, size: 12 }}
          sm={{ order: 1, size: 12 }}
        >
          <div ref={receiptRef} dir="ltr" className="invoice-preview">
            {detail?.map((item, index) => (
              <>
                <div className="page-break" />
                <PreviewCard key={index} data={item} index={index} />
              </>
            ))}
          </div>
        </Col>
        <Col
          lg={{ order: 1, size: 3 }}
          md={{ order: 0, size: 12 }}
          sm={{ order: 0, size: 12 }}
        >
          {/* {data?.map((data,key)=>())} */}
          <PreviewActions
            id={id}
            data={detail[0]}
            setSendSidebarOpen={setSendSidebarOpen}
            setAddPaymentOpen={setAddPaymentOpen}
            handlePrint={handlePrint}
            receiptRef={receiptRef}
          />
          {/* <button onClick={()=>handlePrint()}>Print</button>  */}
        </Col>
      </Row>

      {/* <SendInvoiceSidebar toggleSidebar={toggleSendSidebar} open={sendSidebarOpen} />
      <AddPaymentSidebar toggleSidebar={toggleAddSidebar} open={addPaymentOpen} /> */}
    </div>
  ) : (
    <div className="d-flex justify-content-center align-items-center flex-column">
      <Alert color="danger">
        <h4 className="alert-heading">Invoice not found</h4>
        <div className="alert-body">
          Receipt with id: {id} doesn't exist. Check list of all Receipt:
          <Link to={`/receipts${appView ? "?view=" + appView : ""}`}>
            Receipt List
          </Link>
        </div>
      </Alert>
    </div>
  );
};

export default ReceiptPreview;
